<template>
  <div class="uk-margin uk-width-large uk-margin-auto uk-card uk-card-default uk-card-body uk-box-shadow-large">
    <form @submit.prevent="validateBeforeSubmit">
      <section>
        <h3 class="subtitle">{{title}}
          <router-link to="/">{{name}}</router-link></h3>
        <b-field
          :type="{'is-danger': errors.has('email')}"
          :message="[{
            'Адрес электронной почты обязательное поле для заполнения' : errors.firstByRule('email', 'required')
          }]">
          <b-input
            name="email"
            placeholder="Email"
            type="email"
            icon="at"
            v-validate="'required'"
            v-model="model.email">
          </b-input>
        </b-field>
        <b-field 
          :type="{'is-danger': errors.has('password')}"
          :message="[{
            'Пароль обязательное поле для заполнения' : errors.firstByRule('password', 'required')
          }]">
          <b-input placeholder="Пароль"
            type="password"
            icon="key"
            name="password"
            password-reveal
            v-model="model.password"
            v-validate="'required'">
          </b-input>
        </b-field>
        <vue-recaptcha v-if="need_capcha"
          ref="recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          size="invisible"
          :sitekey="key_capcha">
        </vue-recaptcha>
        <b-field grouped>
          <b-field>
            <button class="button is-primary">Вход</button>
          </b-field>
          <b-field position="is-right">
            <router-link to="/admin/register">
              <button class="button is-primary">Регистрация</button>
            </router-link>
          </b-field>
        </b-field>
      </section>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    errors: '',
});

// import { doLogin , needCaptcha, getCaptchaKey } from "@/api"
import { doLogin } from "@/api"
import { EventBus } from '@/utils'
// import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'Login',
  components: {
    VueRecaptcha: () => import('vue-recaptcha'),
  },
  props: {
    //
  },
  data: function () {
    return {
      title: "Аутентификация в ",
      name: "каталоге ЭНК",
      model: {
        email: '',
        password: ''
      },
      // need_capcha: false,
      // key_capcha: null,
      next: "/admin"
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  computed: {
    need_capcha () {
      return this.$store.getters.isNeedCaptcha
    },
    key_capcha () {
      return this.$store.getters.getCaptchaKey
    }
  },
  mounted () {
    let $this = this

    // getCaptchaKey().then(response => {
    //   if (response.data) {
    //     $this.key_capcha = response.data.data
    //   }
    // })

    // needCaptcha().then(response => {
    //  if (response.data) {
    //    if (response.data.data == true){
    //      $this.need_capcha = true
    //    }
    //  }
    // })

    EventBus.$on('errorAuthentication', (msg) => {
      this.$toast.open({
        message: `${$this.$i18n.t('notify.server_error')}: ${msg}`,
        type: 'is-danger',
        position: 'is-bottom'
      })
      $this.next = "/admin/login"
    })

    EventBus.$on('failedAuthentication', (msg) => {
      this.$toast.open({
        message: `${$this.$i18n.t('notify.error_logged_in')}: ${msg}`,
        type: 'is-danger',
        position: 'is-bottom'
      })
      $this.model.password = ''
      $this.next = "/admin/login"
    })
    
    EventBus.$on('successAuthentication', () => {
      $this.$toast.open({
        message: $this.$i18n.t('notify.success_logged_in'),
        type: 'is-success',
        position: 'is-bottom'
      })
      $this.next = "/admin"
    })
  },
  beforeDestroy () {
    EventBus.$off('errorAuthentication')
    EventBus.$off('failedAuthentication')
    EventBus.$off('successAuthentication')
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this

      if ($this.need_capcha){
        
        $this.$validator.validateAll().then((result) => {
          if (result) {
            $this.$refs.recaptcha.execute();
            return;
          }
          $this.$toast.open({
            message: $this.$i18n.t('notify.form_error'),
            type: 'is-danger',
            position: 'is-bottom'
          })
        });
        
      }
      else{
        this.$validator.validateAll().then((result) => {
          if (result) {
            $this.sendPayload($this.model)
          }
        })
      }
      
    },
    onCaptchaVerified: function (recaptchaToken) {
      let $this = this;
      $this.$refs.recaptcha.reset();

      let payload = $this.model
      payload["g-recaptcha-response"] = recaptchaToken

      $this.sendPayload(payload)
      
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    sendPayload: function (payload) {
      let $this = this;

      $this.$store.dispatch('loginAdmin', payload).then(() => {
        $this.$router.push($this.next)
      })
    }
  }
}
</script>

<style scoped>
</style>
<style>
</style>